<template>
    <div class="holder">
        <component v-bind:is="componentName" :showSp="showSp"></component>
    </div>
</template>

<script>
export default {
    props: {
        game: {
            type: String,
            required: true,
        },
        showSp: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        componentName() {
            return () => import(`./games/${this.game}.vue`);
        },
    },
};
</script>

<style scoped>
.holder {
    height: 100%;
    width: 100%;
}
</style>
